import { Image, Modal } from "react-bootstrap";
import { useAppContext } from "../../hook/AppContext";
import { HeaderTitle } from "../../component/Header";
import CheckoutSteps from "../../component/CheckoutSteps";
import { formatDate, formatNumberWithout } from "../../helper";
import { Calendar, Minus, Plus } from "react-feather";
import { useEffect, useMemo, useState } from "react";
import { booking } from "./fetch";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import qrisImage from "../../assets/qris/qris-payment.jpeg";

const CATEGORY_COLORS = [
  "#f9c824",
  "#5cb85c",
  "#6ea8dc",
  "#22b0a2",
  "#e79cc2",
  "#f0883e",
];

// "CAT 2 - Presale - Sendiri" -> { category: "CAT 2", promo: "Presale", bundle: "Sendiri" }
const parseTicketName = (name) => {
  const parts = (name || "")
    .split(/\s+-\s+/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (parts.length >= 3) {
    return {
      category: parts[0],
      promo: parts[1],
      bundle: parts.slice(2).join(" - "),
    };
  }
  if (parts.length === 2) {
    return { category: parts[0], promo: "", bundle: parts[1] };
  }
  const only = parts[0] || name || "Tiket";
  return { category: only, promo: "", bundle: only };
};

// tampilkan potongan harga jika data menyediakan harga normal / diskon
const getDiscount = (v) => {
  const price = Number(v?.price) || 0;
  const original = Number(
    v?.normal_price ?? v?.real_price ?? v?.price_normal ?? v?.original_price ?? 0
  );
  if (original > price) return original - price;
  const disc = Number(v?.discount) || 0;
  return disc > 0 ? disc : 0;
};

const TicketEvent = () => {
  const navigate = useNavigate();
  const { eventDetail, personalData } = useAppContext();
  const data = eventDetail;

  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showQris, setShowQris] = useState(false);
  const [disableBtnCheckout, setDisableBtnCheckout] = useState(false);
  const [listVariation, setListVariation] = useState([]);
  const [showDetailCheckOut, setShowDetailCheckout] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedPromo, setSelectedPromo] = useState("");

  const addData = (ticketId, variationName, avail, action) => {
    setListVariation((prevList) =>
      prevList.map((item) => {
        if (item.ticket_id === ticketId) {
          return {
            ...item,
            variation: item.variation.map((variation) => {
              if (variation.name === variationName) {
                let newQty = variation.qty ? variation.qty : 0;

                if (action === "increase" && newQty < 10 && newQty < avail) {
                  newQty += 1;
                } else if (action === "decrease") {
                  newQty -= 1;
                }

                if (newQty <= 0) {
                  const { qty, ...rest } = variation;
                  return rest;
                }

                return { ...variation, qty: newQty };
              }
              return variation;
            }),
          };
        }
        return item;
      })
    );
  };

  const calculateTotals = () => {
    let totalPrice = 0;
    let totalQty = 0;

    (listVariation || []).forEach((item) => {
      (item?.variation || []).forEach((variation) => {
        if (variation.qty) {
          totalQty += variation.qty;
          totalPrice += variation.price * variation.qty;
        }
      });
    });

    let adminFee = 0;
    let totalAllPrice = totalPrice + adminFee + 0;
    return { totalAllPrice, totalQty, adminFee };
  };

  const handleBookingEvent = async () => {
    setDisableBtnCheckout(true);
    const loading = toast.loading("Tunggu Sebentar ..");
    try {
      const payload = {
        email: personalData?.email,
        variation: listVariation
          .map((item) => ({
            ...item,
            variation: item.variation.filter((variation) => variation.qty > 0),
          }))
          .filter((item) => item.variation.length > 0),
        phone: personalData?.phone,
        name: personalData?.name,
        gender: personalData?.gender?.value,
        dob: personalData?.dob,
        password: personalData?.password,
        payment_method: "cash",
        token_partnership: secureLocalStorage.getItem("tokenPartner"),
        qty: calculateTotals()?.totalQty,
      };

      const res = await booking(eventDetail?.information?.slug, payload);
      if (res.status) {
        toast.dismiss(loading);
        toast.success("Berhasil Melakukan Pembelian");
        navigate("/");
      } else {
        toast.dismiss(loading);
      }
    } catch (error) {
      toast.dismiss(loading);
    }
  };

  const filterVariations = (variations) => {
    if (!Array.isArray(variations) || variations.length === 0) return [];
    return [...variations].sort((a, b) => a.price - b.price);
  };

  useEffect(() => {
    if (!data) {
      navigate("/");
      return;
    }
    const transformedData = (data?.tickets || []).map((item) => ({
      ticket_id: item.ticket_content.ticket_id,
      title: item.ticket_content.title,
      start_price: item.f_price,
      variation: filterVariations(JSON.parse(item.variations)),
    }));
    setListVariation(transformedData);
  }, [data, navigate]);

  // katalog tiket aktif + urai nama menjadi kategori/promo/bundling
  const catalog = useMemo(() => {
    const active = [];
    (listVariation || []).forEach((item) => {
      (item?.variation || []).forEach((v) => {
        if (v?.status !== "active") return;
        if (!(v?.name || "").trim()) return;
        active.push({
          ...v,
          ...parseTicketName(v.name),
          _ticketId: item.ticket_id,
        });
      });
    });
    const categories = [...new Set(active.map((a) => a.category))];
    return { active, categories };
  }, [listVariation]);

  // pilih kategori pertama secara default
  useEffect(() => {
    if (
      catalog.categories.length &&
      !catalog.categories.includes(selectedCategory)
    ) {
      setSelectedCategory(catalog.categories[0]);
    }
  }, [catalog.categories, selectedCategory]);

  const promos = useMemo(
    () => [
      ...new Set(
        catalog.active
          .filter((a) => a.category === selectedCategory && a.promo)
          .map((a) => a.promo)
      ),
    ],
    [catalog.active, selectedCategory]
  );

  // pilih promo pertama secara default saat kategori berganti
  useEffect(() => {
    if (promos.length) {
      if (!promos.includes(selectedPromo)) setSelectedPromo(promos[0]);
    } else if (selectedPromo !== "") {
      setSelectedPromo("");
    }
  }, [promos, selectedPromo]);

  const bundles = useMemo(
    () =>
      catalog.active.filter(
        (a) =>
          a.category === selectedCategory &&
          (promos.length === 0 || a.promo === selectedPromo)
      ),
    [catalog.active, selectedCategory, selectedPromo, promos.length]
  );

  const totals = calculateTotals();
  const hasOrder = totals.totalQty !== 0;

  if (!data) return null;

  return (
    <div
      className="co-wrap"
      style={{ paddingBottom: hasOrder ? "17rem" : "2rem" }}
    >
      <Modal show={showModalConfirmation} centered>
        <Modal.Body>
          <div className="co-modal-body">
            <p className="co-modal-title">Konfirmasi Pesanan</p>
            <p className="co-modal-sub">
              Pastikan pesanan sudah benar sebelum melanjutkan.
            </p>
            <div className="co-modal-actions">
              <button
                className="co-modal-btn cancel"
                disabled={disableBtnCheckout}
                onClick={() => setShowModalConfirmation(false)}
              >
                Batal
              </button>
              <button
                className="co-modal-btn confirm"
                disabled={disableBtnCheckout}
                onClick={() => handleBookingEvent()}
              >
                Ya, Pesan
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showQris} centered onHide={() => setShowQris(false)}>
        <Modal.Body>
          <div className="qris-modal-body">
            <p className="qris-modal-title">QRIS Pembayaran</p>
            <p className="qris-modal-sub">
              Scan kode berikut untuk melakukan pembayaran.
            </p>
            <div className="qris-frame">
              <img src={qrisImage} alt="QRIS Pembayaran" />
            </div>
            <button
              type="button"
              className="qris-close"
              onClick={() => setShowQris(false)}
            >
              Tutup
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <HeaderTitle title={data?.information?.title} />
      <CheckoutSteps current={2} />

      <div className="co-banner">
        <Image
          src={`${process.env.REACT_APP_API_URL_IMAGE}${data?.thumbnail}`}
          className="co-banner-thumb"
          alt={data?.information?.title}
        />
        <div className="co-banner-info">
          <p className="co-banner-title">{data?.information?.title}</p>
          <p className="co-banner-meta">
            <Calendar size={13} />
            {formatDate(data?.start_date || "")} •{" "}
            {(data?.start_time || "").replace(":", ".")}
          </p>
        </div>
      </div>

      <button
        type="button"
        className="qris-btn"
        onClick={() => setShowQris(true)}
      >
        <FontAwesomeIcon icon={faQrcode} /> Lihat QRIS Pembayaran
      </button>

      <div className="co-section">
        <h5 className="co-section-title">Pilih Tiket</h5>
        <p className="co-section-sub">
          Pilih kategori, promo, lalu jenis bundling tiket.
        </p>
      </div>

      {catalog.categories.length > 0 && (
        <div className="pick-block">
          <p className="pick-label">Pilih Kategori</p>
          <div className="pick-row">
            {catalog.categories.map((cat, i) => (
              <button
                key={cat}
                type="button"
                className={`pick-pill ${
                  selectedCategory === cat ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(cat)}
              >
                <span
                  className="pick-chip"
                  style={{
                    background: CATEGORY_COLORS[i % CATEGORY_COLORS.length],
                  }}
                />
                {cat}
              </button>
            ))}
          </div>
        </div>
      )}

      {promos.length > 0 && (
        <div className="pick-block">
          <p className="pick-label">Promo</p>
          <div className="pick-row">
            {promos.map((promo) => (
              <button
                key={promo}
                type="button"
                className={`pick-pill ${
                  selectedPromo === promo ? "active" : ""
                }`}
                onClick={() => setSelectedPromo(promo)}
              >
                {promo}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="pick-block">
        <p className="pick-label">
          Bundling <span className="pick-hint">· barengan lebih hemat!</span>
        </p>
        {bundles.length > 0 ? (
          <div className="bundle-grid">
            {bundles.map((v, i) => {
              const qty = v?.qty || 0;
              const discount = getDiscount(v);
              const disablePlus =
                qty >= 10 || qty >= (v?.ticket_available || 0);
              return (
                <div
                  key={i}
                  className={`bundle-card ${qty > 0 ? "selected" : ""}`}
                  onClick={() => {
                    if (qty === 0) {
                      addData(v._ticketId, v.name, v.ticket_available, "increase");
                    }
                  }}
                >
                  {discount > 0 ? (
                    <span className="bundle-badge">
                      −Rp {formatNumberWithout(discount)}
                    </span>
                  ) : v?.on_sale === "1" ? (
                    <span className="bundle-badge">SALE</span>
                  ) : null}
                  <p className="bundle-name">{v?.bundle}</p>
                  <p className="bundle-tiket">{v?.allocated_person} Tiket</p>
                  <p className="bundle-price">
                    Rp {formatNumberWithout(v?.price || 0)}
                  </p>
                  <span className="bundle-unit">/orang</span>

                  {qty > 0 && (
                    <div
                      className="bundle-stepper"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        type="button"
                        className="bundle-qty-btn"
                        onClick={() =>
                          addData(
                            v._ticketId,
                            v.name,
                            v.ticket_available,
                            "decrease"
                          )
                        }
                      >
                        <Minus size={16} />
                      </button>
                      <span className="bundle-qty-num">{qty}</span>
                      <button
                        type="button"
                        className="bundle-qty-btn"
                        disabled={disablePlus}
                        onClick={() =>
                          addData(
                            v._ticketId,
                            v.name,
                            v.ticket_available,
                            "increase"
                          )
                        }
                      >
                        <Plus size={16} />
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <p className="co-empty">Belum ada tiket tersedia</p>
        )}
      </div>

      {hasOrder && (
        <div className="co-summary">
          <div
            className="co-summary-toggle"
            onClick={() => setShowDetailCheckout(!showDetailCheckOut)}
          >
            <h6>Detail Pesanan</h6>
            <span className="co-summary-link">
              {showDetailCheckOut ? "Tutup Detail" : "Lihat Detail"}
            </span>
          </div>

          {showDetailCheckOut && (
            <div style={{ marginBottom: 8 }}>
              {listVariation.map((item, index) =>
                item?.variation && item.variation.length > 0
                  ? item.variation
                      .filter(
                        (variation) =>
                          variation &&
                          variation?.ticket_available > 0 &&
                          variation?.qty >= 1
                      )
                      .map((items, indexs) => (
                        <div
                          className="co-detail-item"
                          key={`${index}-${indexs}`}
                        >
                          <span>
                            {items?.name} ({items?.qty}x)
                          </span>
                          <span>
                            {formatNumberWithout(
                              String(items?.qty * items?.price || 0)
                            )}
                          </span>
                        </div>
                      ))
                  : null
              )}
              <div className="co-divider" />
            </div>
          )}

          <div className="co-line">
            <span>Admin Fee</span>
            <span>Rp{formatNumberWithout(0)}</span>
          </div>
          <div className="co-line">
            <span>Internet Fee</span>
            <span>Rp{formatNumberWithout(0)}</span>
          </div>
          <div className="co-line total">
            <span>Total ({formatNumberWithout(totals.totalQty || 0)}x)</span>
            <span>Rp{formatNumberWithout(totals.totalAllPrice)}</span>
          </div>
          <div className="co-line">
            <span>Email Customer</span>
            <span>{personalData?.email}</span>
          </div>

          <button
            className="co-btn mt"
            onClick={() => setShowModalConfirmation(true)}
          >
            Lanjutkan Pesanan
          </button>
        </div>
      )}
    </div>
  );
};

export default TicketEvent;
